import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <p>MegaX Atacadista • plataforma B2B oficial</p>
      <span>Tecnologia e integração por <strong>IGS Automação Comercial</strong></span>
    </footer>
  );
}
